export const linkCv = "https://docs.google.com/document/d/19J2DFNsfPyX3Gc1jW-T2SFZl4u0X8IPJwjkI7IYXUx0/export?format=pdf";